import type { UrlStatusUpdate } from '@kanbu/schema/contracts';

import { UrlListItem } from './url-list-item';

type Props = {
  urls: UrlStatusUpdate[];
  isLoading?: boolean;
};

export function UrlList({ urls, isLoading }: Props) {
  if (!isLoading && urls.length === 0) {
    return null;
  }

  return (
    <ul className='mt-3 flex flex-row flex-wrap gap-2'>
      {urls.map(url => (
        <UrlListItem key={url.id} item={url} isLoading={isLoading} />
      ))}
    </ul>
  );
}
